import { useEffect } from 'react';

import { v4 as uuidv4 } from 'uuid';

export interface IPostData {
    func: string;
    data: any;
}

export interface IPostEvent extends IPostData {
    prom_uuid: string;
    from: string;
    location: string;
}

export interface IPostMessage {
    func: string;
    event: IPostEvent;
}

const postMessage = (data: IPostMessage, target: MessageEvent['source'], origin = '*') =>
    target?.postMessage(data, { targetOrigin: origin });

export const useWindowMessaging = (onMessageEventHandler?: any) => {
    const sendToParent = (payload: IPostData) => {
        let { opener } = window;
        if (!opener) {
            opener = window.parent;
        }

        const data: IPostMessage = {
            func: 'call_prom',
            event: {
                prom_uuid: uuidv4(),
                from: 'all_breakout_rooms',
                location: 'left',
                ...payload
            }
        };
        postMessage(data, opener);
    };

    useEffect(() => {
        if (onMessageEventHandler) {
            window.addEventListener('message', onMessageEventHandler);
        }
        return () => {
            if (onMessageEventHandler) {
                window.removeEventListener('message', onMessageEventHandler);
            }
        };
    }, [onMessageEventHandler]);

    return { sendToParent };
};
